/* unplugin-vue-components disabled */import { render } from "./w-radio-group.vue?vue&type=template&id=4142b22e&scoped=true&ts=true"
import script from "./w-radio-group.vue?vue&type=script&lang=ts"
export * from "./w-radio-group.vue?vue&type=script&lang=ts"

import "./w-radio-group.vue?vue&type=style&index=0&id=4142b22e&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4142b22e"]])

export default __exports__